import { api, setToken, clearToken } from './client';

export interface OnboardingSummary {
  pdpaRequired: boolean;
  pendingSteps: string[];
}

export interface User {
  id: string;
  email: string;
  name: string | null;
  role: string;
  employeeId: string | null;
}

export interface LoginResponse {
  message: string;
  user: User;
  token: string;
  onboarding?: OnboardingSummary;
}

export interface MeResponse {
  user: User;
  onboarding?: OnboardingSummary;
}

export async function login(email: string, password: string, remember = true) {
  const result = await api<LoginResponse>('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });
  if (result.data?.token) setToken(result.data.token, remember);
  return result;
}

export async function logout() {
  await api('/auth/logout', { method: 'POST' });
  clearToken();
}

export async function me() {
  return api<MeResponse>('/auth/me');
}

export async function forgotPassword(email: string) {
  return api<{ message: string }>('/auth/forgot-password', {
    method: 'POST',
    body: JSON.stringify({ email }),
  });
}

export async function resetPassword(email: string, token: string, newPassword: string) {
  return api<{ message: string }>('/auth/reset-password', {
    method: 'POST',
    body: JSON.stringify({ email, token, newPassword }),
  });
}
